"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildAuthorizeUrl = exports.exchangeToken = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _axiosOauthClient = _interopRequireDefault(require("axios-oauth-client"));

var _querystringify = _interopRequireDefault(require("querystringify"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const requestToken = async (client, options) => {
  const authRequest = _axiosOauthClient.default.client(client, options);

  const authCode = await authRequest();

  if (typeof authCode === "string") {
    const authParsed = _querystringify.default.parse(authCode);

    return {
      accessToken: authParsed.access_token,
      refreshToken: authParsed.refresh_token
    };
  }

  return {
    accessToken: authCode.access_token,
    refreshToken: authCode.refresh_token
  };
};

const exchangeToken = async ({
  code,
  state,
  clientId,
  tokenUrl,
  callbackUrl,
  codeVerifier
}) => {
  return requestToken(_axios.default.create(), {
    url: tokenUrl,
    grant_type: "authorization_code",
    state: state,
    client_id: clientId,
    redirect_uri: callbackUrl,
    code: code,
    code_verifier: codeVerifier
  });
};

exports.exchangeToken = exchangeToken;

const buildAuthorizeUrl = (authorizeUrl, {
  clientId,
  callbackUrl,
  scope = "",
  codeChallenge,
  codeChallengeMethod = "S256",
  state = ""
}) => {
  const authorizeParams = _querystringify.default.stringify({
    client_id: clientId,
    redirect_uri: callbackUrl,
    response_type: "code",
    state: state,
    scope: scope,
    code_challenge: codeChallenge,
    code_challenge_method: codeChallengeMethod
  }, true);

  return `${authorizeUrl}${authorizeParams}`;
};

exports.buildAuthorizeUrl = buildAuthorizeUrl;